export const errorCodes = {
  notAvailableLtaWorker: 'CREATE_LTA_WORKER_IS_ALREADY_LTA_IN_OTHER_COMPANY',
  nonApprovedJobsExist: 'NON_APPROVED_JOBS_EXIST',
  noCConFile: 'NO_CREDIT_CARD_SPECIFIED'
};



// WEBPACK FOOTER //
// ./src/constants/errorCodes.js